import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { PaymentSideBarCss as useStyles } from './SupplierCssComponent';
import RightSideBar from '../RightSideBar/RightSideBar';
import * as logger from '../../../logger';
import {
    CardContent,
    CardHeader,
    Card,
    Grid,
    ListItem,
    List
} from '@material-ui/core';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { getVendorPayment, getSupplierTransactHistory, fetchSupplierTransactionLog } from "../../../store/actions/userActionCreators";
import { getSinglePartyPaymentDetails, getPartyTransactHistory } from "../../../store/actions/partiesActionCreator";
import { numberFormat, getMilliDatePickerDateInStringDDMMMYYYY } from '../../../utils/utils';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import DeleteSupplierPaymentDialog from "../Dialog/DeleteSupplierPaymentDialog";
import { withRouter, useHistory, useLocation } from 'react-router-dom';
import { PendingIcon } from '../../../components/icons';
import { trackDwebEvent } from '../../analytics';

const PaymentDetailsSideBar = ({ user, parties, open, onClose, paymentData, dispatchGetSupplierPayment, dispatchGetSupplierTransactHistory, dispatchGetSinglePartyPaymentDetails, dispatchGetPartyTransactHistory, onDelete, invokedFrom }) => {

    let submit;

    const [dialogOpen, setDialogOpen] = useState(open);
    const [paidOnlineFlag, setPaidOnlineFlag] = useState(false);
    const [paymentInfo, setPaymentInfo] = useState({});
    const [tripsList, setTripsList] = useState([]);
    const [deleteDialog, setDeleteDialog] = useState(false);

    let history = useHistory();

    let location = useLocation();


    useEffect(() => {

        if (invokedFrom == "passBookTabSupplier") {

            let path = location && location.pathname ? location.pathname.split("/") : [];

            const vendorIdValue = path && path[path.length - 1] ? path[path.length - 1] : "";

            if (paymentData && paymentData.isBrokerEnabled) {

                // ********************************************** API for Paid Online (Online Payment Verified). **********************************************
                setPaidOnlineFlag(true);
                dispatchGetSupplierTransactHistory(paymentData.id,
                    (data) => {
                        if (data && data.status && data.status.code == 200) {
                            logger.log('Payments Side Bar Supplier Dweb', 'Get Supplier Payment Verified Successfull');
                            trackDwebEvent('Dweb Supplier Transaction Selected', {
                                vendor_id: vendorIdValue,
                                vendor_name: user && user.singleVendorPageName ? user.singleVendorPageName : "",
                                // vendor_contact_number: , 
                                vendor_balance: user && user.singleVendorBalance ? user.singleVendorBalance : 0,
                                transaction_amount: data && data.response && data.response.amount ? data.response.amount : "",
                                transaction_method: "Online",
                                transaction_date: data && data.response && data.response.date ? getMilliDatePickerDateInStringDDMMMYYYY(data.response.date) : "",
                                count_of_trips: data && data.response && data.response.tripDetails ? data.response.tripDetails.length : 1,
                                is_verified_transaction: true
                            });
                        }
                    },
                    () => {
                        logger.log('Payments Side Bar Supplier Dweb', 'Get Supplier Payment Verified Failed');
                    }
                )

            } else {

                // *************************************** API for payments and advance transcation parent type . ***************************************
                setPaidOnlineFlag(false);
                dispatchGetSupplierPayment(paymentData.id,
                    (data) => {
                        if (data && data.status && data.status.code == 200) {
                            logger.log('Payments Side Bar Supplier Dweb', 'Get Supplier Payments Successfull');
                            trackDwebEvent('Dweb Supplier Transaction Selected', {
                                vendor_id: vendorIdValue,
                                vendor_name: user && user.singleVendorPageName ? user.singleVendorPageName : "",
                                // vendor_contact_number: , 
                                vendor_balance: user && user.singleVendorBalance ? user.singleVendorBalance : 0,
                                transaction_amount: data && data.response && data.response.amount ? data.response.amount : "",
                                transaction_method: data && data.response && data.response.paymentMode ? data.response.paymentMode : "",
                                transaction_date: data && data.response && data.response.date ? data.response.date : "",
                                count_of_trips: data && data.response && data.response.attributedTrips ? data.response.attributedTrips.length : 0,
                                is_verified_transaction: false
                            });
                        }
                    },
                    () => {
                        logger.log('Payments Side Bar Supplier Dweb', 'Get Supplier Payments Failed');
                    }
                )
            }
        } else if (invokedFrom == "passBookTabParty") {

            let path = location && location.pathname ? location.pathname.split("/") : [];

            const partyId = path && path[path.length - 1] ? path[path.length - 1] : "";

            if (paymentData && paymentData.isBrokerEnabled) {

                setPaidOnlineFlag(true);
                dispatchGetPartyTransactHistory(
                    Number(paymentData && paymentData.id ? paymentData.id : ""),
                    (data) => {
                        if (data && data.status && data.status.code == 200) {
                            logger.log('Payments Side Bar Supplier Dweb', 'Get Party Payments Successfull');
                        }
                    },
                    () => {
                        logger.log('Payments Side Bar Supplier Dweb', 'Get Party Payments Failed');
                    }
                );

            } else {

                setPaidOnlineFlag(false);
                dispatchGetSinglePartyPaymentDetails(
                    Number(partyId),
                    paymentData.id,
                    (response) => {
                        if (response && response.status && response.status && response.status.code && response.status.code === 200) {
                            logger.log('Payments Side Bar Supplier Dweb', 'Get Party Payments Successfull');
                        }
                    },
                    () => {
                        logger.log('Payments Side Bar Supplier Dweb', 'Get Party Payments Failed');
                    }
                );

            }

        }

    }, [open]);

    // ************************************* Assigning payment Data to respected state variables for rendering . *******************************************
    useEffect(() => {

        if (invokedFrom == "passBookTabSupplier") {
            if (user && user.supplierPaymentData && !paidOnlineFlag) {
                setPaymentInfo(user.supplierPaymentData);
                if (user.supplierPaymentData.attributedTrips) {
                    setTripsList(user.supplierPaymentData.attributedTrips);
                }
            }

            if (user && user.supplierTransactHistory && paidOnlineFlag) {
                setPaymentInfo(user.supplierTransactHistory);
                let tripDetails = [];

                // ****************************************** Extracting First Trip Data in Paid ononline. *********************************** 
                const tripDetailData = {
                    customerId: user && user.supplierTransactHistory && user.supplierTransactHistory.customerId ? user.supplierTransactHistory.customerId : "",
                    customerName: user && user.supplierTransactHistory && user.supplierTransactHistory.customerName ? user.supplierTransactHistory.customerName : "",
                    destinationLocation: user && user.supplierTransactHistory && user.supplierTransactHistory.destinationLocation ? user.supplierTransactHistory.destinationLocation : "",
                    driverId: user && user.supplierTransactHistory && user.supplierTransactHistory.driverId ? user.supplierTransactHistory.driverId : "",
                    driverName: user && user.supplierTransactHistory && user.supplierTransactHistory.driverName ? user.supplierTransactHistory.driverName : "",
                    endDate: user && user.supplierTransactHistory && user.supplierTransactHistory.endDate ? user.supplierTransactHistory.endDate : "",
                    startDate: user && user.supplierTransactHistory && user.supplierTransactHistory.startDate ? user.supplierTransactHistory.startDate : "",
                    startLocation: user && user.supplierTransactHistory && user.supplierTransactHistory.startLocation ? user.supplierTransactHistory.startLocation : "",
                    tripAmount: user && user.supplierTransactHistory && user.supplierTransactHistory.tripAmount ? user.supplierTransactHistory.tripAmount : "",
                    tripId: user && user.supplierTransactHistory && user.supplierTransactHistory.tripId ? user.supplierTransactHistory.tripId : "",
                    vehicleId: user && user.supplierTransactHistory && user.supplierTransactHistory.vehicleId ? user.supplierTransactHistory.vehicleId : "",
                    vehicleNumber: user && user.supplierTransactHistory && user.supplierTransactHistory.vehicleNumber ? user.supplierTransactHistory.vehicleNumber : ""
                }
                tripDetails.push(tripDetailData);

                // *************************************** Checking For Other Trips after single trip . ****************************************
                if (user.supplierTransactHistory.tripDetails && user.supplierTransactHistory.tripDetails.length > 0) {
                    setTripsList(user.supplierTransactHistory.tripDetails);
                } else {
                    setTripsList(tripDetails);
                }
            }
        } else if (invokedFrom == "passBookTabParty") {

            if (parties && parties.singlePaymentDetails && !paidOnlineFlag) {
                setPaymentInfo(parties.singlePaymentDetails);
                if (parties.singlePaymentDetails.attributedTrips) {
                    setTripsList(parties.singlePaymentDetails.attributedTrips);
                }
            }

            if (parties && parties.partyTransactHistory && paidOnlineFlag) {
                setPaymentInfo(parties.partyTransactHistory);
                let tripDetails = [];

                // ****************************************** Extracting First Trip Data in Paid ononline. *********************************** 
                const tripDetailData = {
                    customerId: parties && parties.partyTransactHistory && parties.partyTransactHistory.customerId ? parties.partyTransactHistory.customerId : "",
                    customerName: parties && parties.partyTransactHistory && parties.partyTransactHistory.customerName ? parties.partyTransactHistory.customerName : "",
                    destinationLocation: parties && parties.partyTransactHistory && parties.partyTransactHistory.destinationLocation ? parties.partyTransactHistory.destinationLocation : "",
                    driverId: parties && parties.partyTransactHistory && parties.partyTransactHistory.driverId ? parties.partyTransactHistory.driverId : "",
                    driverName: parties && parties.partyTransactHistory && parties.partyTransactHistory.driverName ? parties.partyTransactHistory.driverName : "",
                    endDate: parties && parties.partyTransactHistory && parties.partyTransactHistory.endDate ? parties.partyTransactHistory.endDate : "",
                    startDate: parties && parties.partyTransactHistory && parties.partyTransactHistory.startDate ? parties.partyTransactHistory.startDate : "",
                    startLocation: parties && parties.partyTransactHistory && parties.partyTransactHistory.startLocation ? parties.partyTransactHistory.startLocation : "",
                    tripAmount: parties && parties.partyTransactHistory && parties.partyTransactHistory.amount ? parties.partyTransactHistory.amount : "",
                    tripId: parties && parties.partyTransactHistory && parties.partyTransactHistory.tripId ? parties.partyTransactHistory.tripId : "",
                    vehicleNumber: parties && parties.partyTransactHistory && parties.partyTransactHistory.vehicleNumber ? parties.partyTransactHistory.vehicleNumber : ""
                }
                tripDetails.push(tripDetailData);

                // *************************************** Checking For Other Trips after single trip . ****************************************
                if (parties.partyTransactHistory.tripDetails && parties.partyTransactHistory.tripDetails.length > 0) {
                    setTripsList(parties.partyTransactHistory.tripDetails);
                } else {
                    setTripsList(tripDetails);
                }

            }
        }

    }, [user.supplierPaymentData, user.supplierTransactHistory, parties.singlePaymentDetails, parties.partyTransactHistory]);

    const classes = useStyles();

    const handleCancel = () => {
        setPaymentInfo({});
        setTripsList([]);
        setDialogOpen(false);
        onClose();
    }

    const handleGoToTrip = (data) => {
        setDialogOpen(false);
        onClose();
        if (data && data.journeyId) {
            history.push({
                pathname: `/trips/view/${data.journeyId}`,
                state: {
                    id: 7,
                    tripData: data,
                    tripView: true,
                    pageTitle: 'Trip Details',
                    pageSubTitle: data && data.vehicleNumber ? data.vehicleNumber : ''
                }
            });
        }
    }

    const handleDelete = () => {
        setDeleteDialog(true);
    }

    const handleDeleteDialogClose = () => {
        setDeleteDialog(false);
    }

    const handleDeleteConfirm = () => {
        let path = location && location.pathname ? location.pathname.split("/") : [];

        const vendorIdValue = path && path[path.length - 1] ? path[path.length - 1] : "";

        // ************************** Closing Sidebar and returning flow to PassBookTabSupplier.js. ******************************
        setDialogOpen(false);
        setDeleteDialog(false);
        onDelete();
        trackDwebEvent('Dweb Supplier Transaction Deleted', {
            vendor_id: vendorIdValue,
            vendor_name: user && user.singleVendorPageName ? user.singleVendorPageName : "",
            // vendor_contact_number: , 
            vendor_balance: user && user.singleVendorBalance ? user.singleVendorBalance : 0,
            transaction_amount: paymentInfo && paymentInfo.amount ? paymentInfo.amount : "",
            transaction_method: paymentData && paymentData.isBrokerEnabled ? "Online" : paymentInfo && paymentInfo.paymentMode ? paymentInfo.paymentMode : "",
            transaction_date: paymentData && paymentData.isBrokerEnabled ? paymentInfo && paymentInfo.date ? (paymentInfo.date) : "" : paymentInfo && paymentInfo.date ? paymentInfo.date : "",
            count_of_trips: paymentInfo && paymentInfo.attributedTrips ? paymentInfo.attributedTrips.length : 0,
            is_verified_transaction: paymentData && paymentData.isBrokerEnabled ? paymentData.isBrokerEnabled : false
        });
    }

    return (
        <>

            {dialogOpen && <RightSideBar
                sideBarName="payment-details"
                rightSideBarOpen={dialogOpen}
                sideBarTitle={paymentInfo && paymentInfo.transactionName && paymentInfo.transactionName =='Opening Balance Payment'?paymentInfo.transactionName:'Payment Details'}
                sideBarType="paymentDetails"
                handleSubmit={event => submit(event)}
                toggleRightSideBar={handleCancel}
                paidOnline={paidOnlineFlag}
                fromPaymentSideBarSupplier={true}
                titleEighteen={true}
                deleteClick={handleDelete}
            >

                <Card className={classes.cardV1}>
                    {paidOnlineFlag &&
                        <CardHeader
                            avatar={
                                <div className={classes.avatar}>
                                    {((invokedFrom == "passBookTabParty" && paymentInfo && paymentInfo.paymentStatus && (paymentInfo.paymentStatus).toLowerCase() == "success") || (paymentInfo && paymentInfo.payoutStatus && (paymentInfo.payoutStatus).toLowerCase() == "success")) &&
                                        <CheckCircleIcon className={classes.doneIcon} />
                                    }
                                    {paymentInfo && paymentInfo.payoutStatus && (paymentInfo.payoutStatus).toLowerCase() == "pending" &&
                                        <PendingIcon className={classes.pendingIcon} />
                                    }
                                </div>
                            }
                            title={<div className={classes.divPayment}>
                                {((invokedFrom == "passBookTabParty" && paymentInfo && paymentInfo.paymentStatus && (paymentInfo.paymentStatus).toLowerCase() == "success") || (paymentInfo && paymentInfo.payoutStatus && (paymentInfo.payoutStatus).toLowerCase() == "success")) &&
                                    <>
                                        Payment Successful
                                    </>
                                }
                                {paymentInfo && paymentInfo.payoutStatus && (paymentInfo.payoutStatus).toLowerCase() == "pending" &&
                                    <>
                                        Payment Pending
                                    </>
                                }
                            </div>}
                            className={invokedFrom == "passBookTabParty" && paymentInfo && paymentInfo.paymentStatus && (paymentInfo.paymentStatus).toLowerCase() == "success" ? classes.cardHeader : paymentInfo && paymentInfo.payoutStatus ? (paymentInfo.payoutStatus).toLowerCase() == "success" ? classes.cardHeader : (paymentInfo.payoutStatus).toLowerCase() == "pending" ? classes.cardHeaderPending : "" : ""}
                        />
                    }
                    <CardContent className={classes.cardContent} >

                        {/* ********************************* 1st Row ************************************ */}
                        <Grid container justify="space-between" wrap="nowrap">
                            <Grid item>
                                <div className={classes.titleV1} >{invokedFrom == "passBookTabParty" ? "Party Name" : "Supplier Name"}</div>
                                {invokedFrom == "passBookTabSupplier" &&
                                    <div className={classes.textV1} >{!paidOnlineFlag ? paymentInfo && paymentInfo.supplierName ? paymentInfo.supplierName : "--" : paymentInfo && paymentInfo.name ? paymentInfo.name : "--"}</div>
                                }
                                {invokedFrom == "passBookTabParty" &&
                                    <div className={classes.textV1} >{!paidOnlineFlag ? paymentInfo && paymentInfo.customerName ? paymentInfo.customerName : "--" : paymentInfo && paymentInfo.name ? paymentInfo.name : "--"}</div>
                                }
                            </Grid>
                            <Grid item>
                                <div className={classes.titleV2} >Payment Amount</div>
                                <div className={classes.textV2}>{paymentInfo && paymentInfo.amount ? numberFormat(paymentInfo.amount) : "--"}</div>
                            </Grid>
                        </Grid>

                        {/* ***************************************** 2nd Row ********************************** */}
                        <Grid container justify="space-between" className={classes.mtV1} wrap="nowrap">
                            <Grid item>
                                <div className={classes.titleV1}>Payment Date</div>
                                {invokedFrom == "passBookTabSupplier" &&
                                    <div className={classes.textV1}>{paymentInfo && paymentInfo.date ? paidOnlineFlag ? getMilliDatePickerDateInStringDDMMMYYYY(paymentInfo.date) : paymentInfo.date : "--"}</div>
                                }
                                {invokedFrom == "passBookTabParty" &&
                                    <div className={classes.textV1}>{paidOnlineFlag ? getMilliDatePickerDateInStringDDMMMYYYY(paymentInfo.date) : paymentInfo && paymentInfo.paymentDate ? paymentInfo.paymentDate : "--"}</div>
                                }
                            </Grid>
                            <Grid item>
                                {paidOnlineFlag &&
                                    <>
                                        <div className={classes.titleV2}>Transcation ID</div>
                                        <div className={classes.textV2}>{paymentInfo && paymentInfo.paymentRefId ? paymentInfo.paymentRefId : "--"}</div>
                                    </>
                                }
                                {!paidOnlineFlag &&
                                    <>
                                        <div className={classes.titleV2}>Reference Number</div>
                                        <div className={classes.textV2}>{paymentInfo && paymentInfo.paymentData ? paymentInfo.paymentData : "--"}</div>
                                    </>
                                }
                            </Grid>
                        </Grid>

                        {/* *************************************** 3rd Row *********************************** */}
                        {invokedFrom == "passBookTabSupplier" && paidOnlineFlag &&
                            <Grid container justify="space-between" className={classes.mtV1} wrap="nowrap">
                                <Grid item>
                                    <div className={classes.titleV1}>Bank</div>
                                    <div className={classes.textV1}>{paymentInfo && paymentInfo.bankName ? paymentInfo.bankName : "--"}</div>
                                </Grid>
                                <Grid item>
                                    <div className={classes.titleV2}>Account</div>
                                    <div className={classes.textV2}>{paymentInfo && paymentInfo.accNumber ? paymentInfo.accNumber : "--"}</div>
                                </Grid>
                            </Grid>
                        }

                        {/* ***************************************** 4th Row. ***************************************** */}
                        {!paidOnlineFlag &&
                            <Grid container justify="space-between" className={classes.mtV1} wrap="nowrap">
                                <Grid item>
                                    <div className={classes.titleV1}>Payment method</div>
                                    <div className={classes.textV1}>{paymentInfo && paymentInfo.paymentMode ? paymentInfo.paymentMode : ""}</div>
                                </Grid>
                                {paymentInfo && invokedFrom == "passBookTabParty" && paymentInfo.isPaidToDriver &&
                                    <Grid item>
                                        <div className={classes.titleV2}>Paid To Driver</div>
                                        <div className={classes.textV2}>{paymentInfo && paymentInfo.driverName ? paymentInfo.driverName : ""}</div>
                                    </Grid>
                                }
                            </Grid>
                        }

                        {/* ****************************************** 5th Row. ****************************************** */}
                        {!paidOnlineFlag &&
                            <div className={classes.mtV1}>
                                <div className={classes.titleV1}>Notes</div>
                                <div className={classes.textV1}>{paymentInfo && paymentInfo.description ? paymentInfo.description : "--"}</div>
                            </div>
                        }

                        {/* ****************************************** 6th Row. ****************************************** */}
                        {paidOnlineFlag && invokedFrom == "passBookTabParty" && paymentInfo.driverName &&
                            <div className={classes.mtV1}>
                                <div className={classes.titleV1}>Paid To Driver</div>
                                <div className={classes.textV1}>{paymentInfo && paymentInfo.driverName ? paymentInfo.driverName : ""}</div>
                            </div>
                        }

                    </CardContent>
                </Card>

                {/* ************************************** Trip Details Cards ************************************* */}
                {(tripsList && tripsList.length > 0 && paymentInfo && paymentInfo.transactionName && paymentInfo.transactionName !='Opening Balance Payment') &&
                    <>
                        <hr className={classes.hrV1} />

                        <div className={classes.divTripDetails} >
                            <div className={classes.divAlign}>
                                <div className={classes.tripDetailsText}>{tripsList.filter((t)=>t&&t.tripName&&t.tripName=='Opening Balance Payment').length>0?'PAYMENT DETAILS':'TRIP DETAILS'}</div>
                                <div className={classes.tripDetailsText}>AMOUNT LINKED</div>
                            </div>

                            <List>
                                {tripsList.map((tripDetails, index) => (
                                    <ListItem className={index == 0 ? classes.cardV2 : classes.cardV3} button onClick={() => handleGoToTrip(tripDetails)} >

                                        <Grid container justify="space-between">
                                            <Grid item className={classes.textV3} >
                                                {paidOnlineFlag ? tripDetails && tripDetails.startLocation ? tripDetails.startLocation + " - " + tripDetails.destinationLocation : "" : tripDetails && tripDetails.tripName ? tripDetails.tripName : ""}
                                            </Grid>
                                            <Grid item className={classes.amountV1} >
                                                {paidOnlineFlag ? tripDetails && tripDetails.tripAmount ? numberFormat(tripDetails.tripAmount) : "" : tripDetails && tripDetails.attributedAmount ? numberFormat(tripDetails.attributedAmount) : ""}
                                            </Grid>
                                        </Grid>

                                        <Grid container className={classes.mtV2} alignItems="center">
                                            <Grid item className={classes.textV4}>
                                                {paidOnlineFlag ? tripDetails && tripDetails.startDate ? getMilliDatePickerDateInStringDDMMMYYYY(tripDetails.startDate) : "" : tripDetails && tripDetails.tripStartDate ? tripDetails.tripStartDate : ""}
                                            </Grid>
                                            {tripDetails && tripDetails.vehicleNumber &&
                                                <>
                                                    <FiberManualRecordIcon className={classes.dotV1} />
                                                    <Grid item className={classes.textV4}>
                                                        {tripDetails && tripDetails.vehicleNumber ? tripDetails.vehicleNumber : ""}
                                                    </Grid>
                                                </>
                                            }
                                        </Grid>
                                    </ListItem>
                                ))}
                            </List>
                        </div>
                    </>
                }


            </RightSideBar>
            }

            {/* ********************************************************** Delete Payment Dialog. ********************************************************** */}
            {deleteDialog &&
                <DeleteSupplierPaymentDialog open={deleteDialog} onClose={handleDeleteDialogClose} onConfirm={handleDeleteConfirm} paymentId={paymentInfo && paymentInfo.id ? paymentInfo.id : ""} calledFrom={invokedFrom} />
            }
        </>
    )

}

const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({
    dispatchGetSupplierPayment: (paymentId, onSuccess, onError) => {
        dispatch(getVendorPayment(paymentId, onSuccess, onError))
    },
    dispatchGetSupplierTransactHistory: (paymentId, onSuccess, onError) => {
        dispatch(getSupplierTransactHistory(paymentId, onSuccess, onError))
    },
    dispatchGetSinglePartyPaymentDetails: (partyId, paymentId, onSuccess, onFailure) => {
        dispatch(getSinglePartyPaymentDetails(partyId, paymentId, onSuccess, onFailure))
    },
    dispatchGetPartyTransactHistory: (partyId, onSuccess, onError) => {
        dispatch(getPartyTransactHistory(partyId, onSuccess, onError))
    },

});

export default connect(mapStateToProps, mapDispatchToProps)(PaymentDetailsSideBar);